import DVActionsButton from 'plugins/deep-visibility/log-details-renderers/DVActionsButton';
import { ActionMenuItem, DataRow, EventAction } from 'plugins/types';
import { Query } from 'common/graphqlTypes';

import { agentsActions, endpointActionsCategories, shortcutsActions } from './actions';
import EventActionsExecutor from './EventActionsExecutor';

const getEndpointActions = (
  availableActions: { name: string; isDisabled: boolean; disabledReason?: string }[],
): ActionMenuItem[] => {
  const filteredAgentActions = agentsActions.reduce((acc: ActionMenuItem[], action: EventAction) => {
    const actionKey = action.actionName || action.actionId;
    const availableAction = availableActions.find(({ name }) => actionKey === name);
    if (availableAction) {
      acc.push({
        ...action,
        disabled: !availableAction || availableAction?.isDisabled,
        disabledReason: availableAction?.disabledReason,
      });
    }
    return acc;
  }, []);

  return [...filteredAgentActions, ...shortcutsActions];
};

const ActionsButton = ({ values, initialData }: { values: DataRow; initialData?: Partial<Query> }) => {
  const availableActions = initialData?.s1Endpoint?.availableActions?.data || [];
  const endpointActions = getEndpointActions(availableActions);

  return (
    <DVActionsButton
      actionsList={endpointActions}
      actionsExecutor={EventActionsExecutor}
      categories={endpointActionsCategories}
      label="Endpoint Actions"
      values={values}
      initialData={initialData}
    />
  );
};

export default ActionsButton;
